export const fi = {
  "landingPage": {
    "startSearch": "Etsi kohteita",
    "latestListings": "Uusimmat kohteet",
    "map": {
      "title": "Asuntokartta"
    },
    "couldBuyOrCouldSellModal": {
      "sell": {
        "title": "Voisin myydä",
        "description": "Hienoa! Kun annat vielä osoitteen ja vahvistat myyntikiinnostuksesi, yhdistämme sinut ostajiin anonyymisti. Voit halutessasi tarkentaa kiinnostustasi ja perua sen milloin tahansa."
      },
      "buy": {
        "title": "Voisin ostaa",
        "description": "Hienoa! Kun annat vielä osoitteen ja vahvistat ostokiinnostuksesi, yhdistämme sinut myyjiin anonyymisti. Voit halutessasi tarkentaa kiinnostustasi ja perua sen milloin tahansa."
      },
      "submitError": "Virhe lähetettäessä. Yritä uudelleen.",
      "addressMismatch": "Rakennuksen osoite ei vastaa syötettyä osoitetta. Tarkista osoite tai valitse eri rakennus. Rakennuksen reunalla klikkaamminen saattaa joskus valita naapurirakennuksen osoitteen."
    }
  },
  "common": {
    "showMore": "Näytä lisää",
    "showLess": "Näytä vähemmän",
    "readMore": "Lue lisää...",
    "findingLocation": "Ladataan sijaintiasi...",
    "cancel": "Peruuta",
    "optional": "valinnainen"
  },
  "propertyMap": {
    "title": "Asuntokartta",
    "exploreHint": "Zoomaa, etsi talo, tutki, myy, osta"
  },
  "feed": {
    "title": "Viimeisimmät",
    "button": {
      "showFeed": "Avaa",
      "hideFeed": "Sulje"
    },
    "likeBuildingEvent": {
      "text": "Käyttäjä tykkäsi talosta"
    },
    "offMarketWillingnessEvent": {
      "sell": {
        "text": "Hiljaisessa myynnissä"
      },
      "buy": {
        "text": "Kiinnostunut ostaja"
      }
    },
    "sellerBuyerOverlapEvent": {
      "text": "Myyjät ja ostajat samassa talossa!"
    }
  },
  "map": {
    "showMap": "Näytä asuntokartta",
    "showFeed": "Näytä asuntofiidi"
  },
  "navbar": {
    "login": "Kirjaudu",
    "loggedIn": "Kirjautunut",
    "messages": "Yksitysviestit",
    "jaakkoInfo": "Jaakko info"
  },
  "searchInput": {
    "placeholder": "Etsi talo - myy, osta ja tutki"
  },
  "mainMenu": {
    "whatIsJaakko": "Mikä Jaakko.com on?",
    "contact": "Yhteystiedot",
    "termsConditions": "Käyttöehdot",
    "privacyPolicy": "Tietosuoja",
    "cookies": "Evästeet",
    "language": "Kieli",
    "feedback": "Anna palautetta"
  },
  "timeAgo": {
    "justNow": "Nyt",
    "minutes": "{{count}} min",
    "hours": "{{count}} h",
    "days": "{{count}} vrk"
  },
  "couldBuyOrCouldSellModal": {
    "couldSellTitle": "Voisin myydä",
    "couldBuyTitle": "Voisin ostaa"
  },
  "building": {
    "controls": {
      "follow": "Seuraa",
      "share": "Jaa",
      "like": "Tykkää"
    },
    "generalInfo": {
      "property": "Kohde",
      "plot": "Tontti",
      "redemptionClause": {
        "title": "Lunastuspykälä",
        "yes": "Kyllä",
        "no": "Ei"
      },
      "plotOwnership": {
        "title": "Tontti",
        "owned": "Oma",
        "rented": "Vuokra"
      }
    },
    "apartments": {
      "title": "Huoneistot",
      "units": {
        "count": "{{count}} kpl",
        "countEmpty": "- kpl"
      },
      "roomCount": "{{count}}h",
      "fourPlusRooms": "4h+"
    },
    "offMarket": {
      "title": "Asuntokauppa",
      "titleContractor": "Kiinnostukset",
      "emptyPlaceholder": {
        "firstLine": "Ei vielä kiinnostuksia.",
        "secondLine": "Voisitko myydä tai ostaa täältä? Paina nappia. ☝️"
      },
      "couldSell": "Voisin myydä",
      "couldBuy": "Voisin ostaa",
      "contractorInterest": "Kiinnostaa",
      "shareTitle": {
        "couldSell": "Hiljaisessa myynnissä",
        "couldBuy": "Ostokiinnostus"
      },
      "sharedEvent": {
        "sellTitle": "Myyntikiinnostus",
        "buyTitle": "Ostokiinnostus",
        "description": "Tämä ilmoitus on jaettu sinulle."
      },
      "count_one": "{{count}} kpl",
      "count_other": "{{count}} kpl",
      "contractorPrebooking": "{{count}} tulossa myyntiin",
      "infoButton": "Mitä nämä ovat",
      "infoModalText": "Voisitko myydä tai haluaisitko ostaa täältä? Ilmaise kiinnostuksesi napin painalluksella – helpommin kuin koskaan! Yhdistämme sinut vastapuolen kiinnostuneisiin täysin anonyymisti ja ilman sitoumuksia. Keskustelu välillänne aukeaa suoraan Yksityisviestit-osiossa ja sähköpostiosoitteesi näytetään toiselle osapuolelle vain, jos päätät lähettää viestin tai vastata saamaasi tiedusteluun. Voit myös poistaa kiinnostuksesi milloin tahansa. <1>Lue lisää...</1>",
      "toast": {
        "couldSellNoBuyers": "Hienoa! Kun kiinnostunut ostaja löytyy, saat tiedon sähköpostiisi.",
        "couldSellAndBuyers": "Myös ostajat ovat kiinnostuneita, voitte nyt keskustella Viestit-osiossa!",
        "couldBuyNoSellers": "Hienoa! Kun kiinnostunut omistaja löytyy, saat tiedon sähköpostiisi.",
        "couldBuyAndSellers": "Myös omistajat ovat kiinnostuneita, voitte nyt keskustella Viestit-osiossa!",
        "userSellerAndBuyer": "Et voi olla sekä myyjä että ostaja samanaikaisesti.",
        "couldBuyContractor": "Hienoa! Voit nyt keskustella suoraan rakennuttajan kanssa."
      },
      "modal": {
        "sell": {
          "title": "Vahvista myyntikiinnostus",
          "description": "Hienoa! Kun vielä vahvistat myyntikiinnostuksesi, yhdistämme sinut ostajiin anonyymisti. Voit halutessasi tarkentaa kiinnostustasi ja perua sen milloin tahansa."
        },
        "buy": {
          "title": "Vahvista ostokiinnostus",
          "description": "Hienoa! Kun vielä vahvistat ostokiinnostuksesi, yhdistämme sinut myyjiin anonyymisti. Voit halutessasi tarkentaa kiinnostustasi ja perua sen milloin tahansa."
        },
        "contractor": {
          "olasIntroKuninkaantammi": "Nyt 'ennakko-ennakko-varattavissa' upeita rivitalokoteja Kuninkaantammesta! Näitä et löydä muualta – voit osoittaa kiinnostuksesi helposti painamalla Kiinnostaa-nappia.\n\nAsunto-osakeyhtiö koostuu kaksikerroksisista rivitalokodeista. Puurakenteisten asuntojen suunnittelussa on tehty kestäviä ja korkealaatuisia ratkaisuja, kuten keskitetty maalämpö, aurinkopaneelivaraukset, parkettilattiat, listattomat ikkunat ja integroidut astianpesukoneet. Asiantuntijoidemme valitseman väri-, pintamateriaali – ja kiintokalustevalikoiman avulla jokaisesta asunnosta muovautuu asukkaidensa näköinen koti.\n\n •\tTerassi ja osittain tuija-aidoin rajattu piha laajentavat omaa asuintilaa\n •\tSuuret ikkunat tuovat tiloihin runsaasti luonnonvaloa\n •\tHyvin suunnitellut ja korkealaatuiset Puustellin keittiöt sujuvoittavat ruoanlaittoa\n •\tAsiantuntijoidemme Laattapisteen laajasta valikoimasta valitsemat vaihtoehdot kestävät aikaa ja katsetta\n •\tPuusepän käsityönä valmistama sauna lasiseinineen luo viihtyisää kylpylätunnelmaa\n\n Asunnot sijaitsevat Kuninkaantammen asuinalueella, jossa yhdistyy viihtyisä rauhallisuus ja palveluiden läheisyys. Asuntojen läheltä löytyvät koulut, päiväkodit ja kaupat luovat sujuvan arjen. Arkea helpottaa entisestään liikenneyhteyksien mahdollistama tehokas liikkuminen ympäri pääkaupunkiseutua. Kuninkaantammi tarjoaa tämän lisäksi runsaasti mahdollisuuksia erilaisiin harrastuksiin ja rentoutumismuotoihin.",
          "olasIntroViertola": "Nyt 'ennakko-ennakko-varattavissa' upeita rivitalokoteja Viertolasta! Näitä et löydä muualta – voit osoittaa kiinnostuksesi helposti painamalla Kiinnostaa-nappia.\n\nAsunto-osakeyhtiö koostuu yksi- ja kaksikerroksisista rivitalokodeista. Puurakenteisten asuntojen suunnittelussa on tehty kestäviä ja korkealaatuisia ratkaisuja, kuten keskitetty maalämpö, aurinkopaneelivaraukset, parkettilattiat, listattomat ikkunat ja integroidut astianpesukoneet. Asiantuntijoidemme valitseman väri-, pintamateriaali – ja kiintokalustevalikoiman avulla jokaisesta asunnosta muovautuu asukkaidensa näköinen koti.\n\n• Terassi ja osittain tuija-aidoin rajattu piha laajentavat omaa asuintilaa\n• Suuret ikkunat tuovat tiloihin runsaasti luonnonvaloa\n• Hyvin suunnitellut ja korkealaatuiset Puustellin keittiöt sujuvoittavat ruoanlaittoa\n• Asiantuntijoidemme Laattapisteen laajasta valikoimasta valitsemat vaihtoehdot kestävät aikaa ja katsetta\n• Puusepän käsityönä valmistama sauna lasiseinineen luo viihtyisää kylpylätunnelmaa\n\nRivitalokodit sijaitsevat Viertolan asuinalueella, jossa yhdistyy viihtyisä kylämäisyys ja keskeinen sijainti. Koko perheen huomioivien palveluiden, monien luontoalueiden ja loistavien liikenneyhteyksien ansiosta asunnoissa arki on vaivatonta. Alue tarjoaa kaiken päiväkodeista ja koirapuistoista urheilukenttiin. Myytävien asuntojen läheisyydessä sijaitsevat kaupat, ravintolat ja kahvilat tekevät arjesta helppoa. Kotien viihtyisyyttä korostaa aluetta ympäröivä ainutlaatuinen ja monipuolisiin harrastuksiin taipuva ympäristö.",
          "buyDescription": "Hienoa! Vahvistamalla valintasi yhdistämme sinut Olaksen myyntiedustajaan. Tässä vaiheessa et vielä sitoudu mihinkään ja voit poistaa ostokiinnostuksesi milloin tahansa."
        },
        "edit": {
          "menuTitle": "Muokkaa",
          "title": "Muokkaa ilmoitusta",
          "sellDescription": "Päivitä myyntikiinnostuksesi tiedot.",
          "buyDescription": "Päivitä ostokiinnostuksesi tiedot."
        },
        "confirm": "Vahvista",
        "delete": "Poista",
        "deleteConfirmTitle": "Poista ilmoitus",
        "deleteConfirmText": "Haluatko varmasti poistaa tämän ilmoituksen?",
        "remove": {
          "menuTitle": "Poista"
        },
        "update": "Päivitä",
        "cancel": "Peruuta",
        "detailsOptional": "Asunnon tiedot (Valinnainen)",
        "description": "Kuvaus",
        "buyingInterestDescriptionPlaceholder": "Lisää tietoja asunnoista, joista olet kiinnostunut...",
        "sellingInterestDescriptionPlaceholder": "Lisää tietoja asunnosta, jonka voisit myydä...",
        "additionalDetails": "Anna lisätietoja (valinnainen)",
        "size": "Koko (m²)",
        "sizePlaceholder": "esim. 65",
        "sizeClass": "Kokoluokka (m²)",
        "rooms": "Huonetta",
        "rooms_one": "Huone",
        "rooms_other": "Huonetta",
        "roomsLabel": "Huoneita",
        "selectRooms": "Valitse huoneiden määrä",
        "floor": "Kerros",
        "floorPlaceholder": "esim. 3",
        "renovation": "Remonttitilanne",
        "selectRenovation": "Valitse kunto",
        "recentlyRenovated": "Äskettäin remontoitu",
        "goodCondition": "Hyvä kunto",
        "needsRenovation": "Tarvitsee remonttia",
        "hasElevator": "Hissi",
        "hasBalcony": "Parveke/terassi",
        "address": "Katuosoite",
        "addressPlaceholder": "Esim. Keskuskatu 1, 00100 Helsinki",
        "loading": "Ladataan...",
        "checkingBuilding": "Tarkistetaan rakennusta...",
        "buildingFound": "Rakennus löytyi tästä osoitteesta",
        "sellInterestNoBuildingFound": "Rakennusta ei löytynyt, lisää myyntikiinnostuksesi Asuntokartta-toiminnon kautta.",
        "buyInterestNoBuildingFound": "Rakennusta ei löytynyt, lisää ostokiinnostuksesi Asuntokartta-toiminnon kautta.",
        "incompleteAddress": "Valitse valikosta koko osoite, myös talon numero ja kaupunki, esim. Keskuskatu 1, Helsinki. Voit valita talon myös Asuntokartalta.",
        "addPropertyImages": "Lisää kuvia asunnosta (Max. 30)",
        "dragImagesHere": "Valitse tiedosto tai pudota tähän",
        "propertyImage": "Kuva asunnosta",
        "removeImage": "Poista kuva",
        "uploadFailed": "Lataus epäonnistui",
        "imageLimitExceeded": "Max. {{max}} kuvaa sallittu",
        "pleaseSelectAddress": "Valitse osoite",
        "sellInterestRegistered": "Myyntikiinnostuksesi on rekisteröity onnistuneesti!",
        "buyInterestRegistered": "Ostokiinnostuksesi on rekisteröity onnistuneesti!",
        "submitError": "Virhe lähetettäessä. Yritä uudelleen.",
        "sizeMustBeGreaterThanZero": "Virheellinen koko.",
        "clickBuildingInstruction": "Valitse oikea rakennus osoitteesta kartalta.",
        "buildingSelected": "Rakennus valittu",
        "receivedAddress": "Rakennuksen osoite:"
      }
    },
    "housingCompanyHoldings": {
      "title": "Taloyhtiön omistukset",
      "apartments": "Huoneistoja",
      "commercialSpaces": "Liiketiloja",
      "units": "kpl"
    },
    "jaakko": {
      "sendFeedback": "Lähetä palautetta"
    },
    "housingCompanyInfo": {
      "title": "Taloyhtiön lisätiedot"
    },
    "map": {
      "title": "Kartta"
    },
    "comments": {
      "title": "Yleinen keskustelu",
      "emptyState": "<0>Täällä voit keskustella talosta julkisesti.</0><1>Aloita anonyymi keskustelu! 🥳</1>",
      "placeholder": "Jaa kokemuksesi talosta, lisää kuva tai kysy jotain.",
      "send": "Lähetä",
      "back": "Takaisin",
      "pickPhoto": "Valitse kuva",
      "takePhoto": "Ota kuva",
      "commenterOrderNumberFirst": "Eka."
    },
    "filesDropBox": {
      "title": "Lataa yhtiöjärjestys, tilinpäätös, kunnossapitotarveselvitys tai muita liittyviä dokumentteja."
    },
    "documentDropzone": {
      "clickToUpload": "<0>Valitse tiedosto</0> <2>tai pudota tähän</2>",
      "termsAgreement": "Lähettämällä dokumentteja sitoudut noudattamaan palveluidemme <1>käyttöehtoja</1>, sekä ilmoitat lukeneesi ja hyväksyväsi Jaakkocom Oy:n <3>yleisen tietosuojakuvauksen</3>.",
      "buttonText": "Analysoi",
      "loading": {
        "title": "Koostan raporttia tietojen pohjalta.",
        "text": "Tässä voi mennä muutama minuutti..."
      }
    },
    "buildingInfoBox": {
      "title": "Taloyhtiö"
    },
    "financialsInfoBox": {
      "title": "Talous"
    },
    "renovationsInfoBox": {
      "title": "Remontit"
    },
    "maintenanceNeedsAssessmentPlaceHolderText": "Syötä taloyhtiön kunnossapitotarveselvitys, tai PTS -suunnitelma, saadaksesi analyysin",
    "articlesOfAssociationPlaceHolderText": "Syötä taloyhtiön yhtiöjärjestys, saadaksesi analyysin",
    "financialStatementPlaceHolderText": "Syötä taloyhtiön tilinpäätös, tai talousarvio, saadaksesi analyysin",
    "streetView": {
      "title": "Katunäkymä"
    }
  },
  "mainMenuPages": {
    "faq": {
      "title": "Usein kysytyt kysymykset",
      "whatIsJaakko": {
        "title": "Mikä Jaakko.com on?",
        "paragraphs": {
          "first": "Jaakko.com on uudenlainen palvelu, joka yhdistää ostajat ja myyjät toisiinsa helpommin kuin koskaan, ilman sitoumuksia. Jos et löydä kiinnostavaa kohdetta nykyisistä palveluista tai harkitset myymistä ilman raskasta ja monimutkaista prosessia, Jaakko.com tarjoaa yksinkertaisen ja tehokkaan tavan uudenlaiselle kaupankäynnille.",
          "second": "Käyttäjät voivat myös keskustella, jakaa tietoa ja kuvia sekä esittää kysymyksiä mistä tahansa rakennuksesta. Keskustelun avulla voi oppia lisää eri kohteista ja saada arvokasta näkemystä muilta käyttäjiltä.",
        }
      },
      "sellingAndBuying": {
        "title": "Ostaminen ja myyminen Jaakko.comin kautta",
        "howItWorks": {
          "title": "Miten se toimii?",
          "bulletPoints": {
            "express": "Valitse talo kartalta ja ilmaise kiinnostuksesi ostamiseen tai myymiseen yhdellä napin painalluksella. Muille käyttäjille näkyy vain, että joku talosta saattaa olla valmis keskustelemaan – ei muuta. Voit halutessasi lisätä myyntikiinnosukseesi lisätietoja ja kuvia, jolloin ostajat saavat heti parhaan käsityksen kohteesta suoraan asuntofiidissä.",
            "connect": "Kun kiinnostus on molemminpuolista, saat tiedon sähköpostiisi, ja osapuolille avautuu suora keskustelumahdollisuus palvelussa.",
            "anonymous": "Kaikki on aluksi täysin anonyymiä – sähköpostiosoitteesi jaetaan vasta, jos päätät vastata vastapuolen yhteydenottoon tai lähettää itse viestin.",
            "information": "Voit aloittaa keskustelun esimerkiksi kertomalla, mikä sinua kiinnostaa, kuten \"Voisin myydä 2h\" tai \"Etsin perheasuntoa talosta\".",
            "removeinterest": "Voit koska tahansa poistaa kiinnostuksesi yhdellä napin painalluksella, jolloin uusia yhteydenottoja ei enää tule.",
            "removechat": "Voit poistaa minkä tahansa keskustelun koska tahansa. Tällöin et enää saa viestejä kyseiseltä vastapuolelta."
          },
        },
        "safety": {
          "title": "Huomioithan turvallisuuden ja hyvät tavat:",
          "bulletPoints": {
            "first": "Jaakko.com on tarkoitettu yhteyksien luomiseen – palvelu ei osallistu varsinaiseen kaupankäyntiin eikä varmista osapuolten henkilöllisyyttä.",
            "second": "Varmista aina vastapuolen henkilöllisyys ennen päätöksiä tai maksuja. Tämä voi tapahtua esimerkiksi tapaamalla kasvotusten tai pyytämällä virallisia asiakirjoja.",
            "third": "Käytä tarvittaessa asiantuntijoita, kuten välittäjää tai juristia, varmistaaksesi turvallisen kaupanteon.",
            "fourth": "Viesteissä ei saa esittää loukkaavia, laittomia, häiritseviä tai valheellisia väitteitä, eikä mitään sisältöä, joka rikkoo lakeja tai hyviä tapoja.",
            "fifth": "Jaakko.com pidättää oikeuden poistaa keskusteluja ja käyttäjiä, jotka rikkovat palvelun sääntöjä tai hyviä tapoja.",
            "sixth": "Noudattamalla näitä ohjeita varmistat, että palvelun käyttö on turvallista ja mukavaa kaikille osapuolille."
          }
        }
      },
      "benefits": {
        "title": "Mitä hyötyä Jaakko-tunnuksesta on?",
        "paragraphs": {
          "first": "Voit selata rakennuksia ilman tunnusta, mutta Jaakko-tunnuksella saat käyttöösi lisäominaisuuksia:",
          "second": "Jaakko-tunnuksen luominen on maksutonta ja vie vain minuutin!"
        },
        "bulletPoints": {
          "first": "Ilmaise kiinnostuksesi myymiseen tai ostamiseen missä tahansa rakennuksessa.",
          "second": "Osallistu keskusteluun ja jaa kokemuksia.",
          "third": "Seuraa kiinnostavia kohteita ja saa ilmoituksia uusista tiedoista.",
          "fourth": "Jaa taloja ystäviesti kanssa.",
          "fifth": "Tykkää kiinnostavia taloja."
        }
      },
      "howToParticipate": {
        "title": "Miten osallistun keskusteluun?",
        "paragraph": "Keskustelu ja kuvien jakaminen palvelussa on anonyymiä, mutta edellyttää Jaakko-tunnusta. Keskusteluissa tulee noudattaa hyviä tapoja, eikä niissä saa mainita omia tai muiden nimiä tai muita yhteystietoja. Lisäksi keskusteluissa ei saa esittää loukkaavia, laittomia, häiritseviä tai valheellisia väitteitä, eikä mitään sisältöä, joka rikkoo lakeja tai hyviä tapoja."
      },
      "documentAnalysis": {
        "title": "Jaakosta löytyy myös uudiskohteita – mitä se tarkoittaa?",
        "paragraphs": {
          "first": "Yhteistyössä rakennuttajien kanssa Jaakko tuo ostajien saataville myös uudiskohteita, joita ei vielä ole markkinoilla – ei edes rakenteilla. Tämä on mahdollisuus varata ja vaikuttaa jo ennen ennakkomarkkinoinnin alkamista. Näitä kohteita ei löydy muualta.",
          "second": "Voit osoittaa kiinnostuksesi yhdellä Kiinnostaa-napin painalluksella – napin painaminen ei vielä sido mihinkään. Sen jälkeen voit keskustella suoraan rakennuttajan kanssa, kysyä kysymyksiä, vaikuttaa ja varata ajoissa."
        }
      },
      "typesOfRealEstate": {
        "title": "Minkälaisia kohteita Jaakko kattaa?",
        "paragraph": "Karttapohjainen käyttöliittymä mahdollistaa tutustumisen rakennuksiin, keskustelun ja osto- ja myyntikiinnostuksen osoittamisen kaikkialla maailmassa. Mikäli kohteella ei ole tarkkaa osoitetta (kesämökit saarissa, jne.), puuttuvat ne palvelusta vielä osittain."
      },
      "payments": {
        "title": "Maksullisuus",
        "paragraph": "Palvelun perustoiminnot ovat veloituksettomia, mutta tietyistä ominaisuuksista ja lisäpalveluista voidaan tulevaisuudessa periä maksu. Palvelun veloitukseton käyttö ei velvoita jatkossa mihinkään."
      },
      "feedback": {
        "title": "Miten voin antaa palautetta?",
        "paragraph": "Kaikki palaute on tervetullutta. Voit lähettää palautteesi osoitteeseen support@jaakko.com. Kehitämme palvelua jatkuvasti ja arvostamme käyttäjien näkemyksiä."
      }
    },
    "contactUs": {
      "title": "Yhteystiedot",
      "customerSupport": "Asiakaspalvelu:",
      "businessId": "Y-tunnus:",
      "country": "Suomi"
    }
  },
  "signupLoginModal": {
    "loginOrSignup": "Kirjaudu tai luo tunnus",
    "continueWithGoogle": "Jatka Googlella",
    "continueWithFacebook": "Jatka Facebookilla",
    "orContinueWithEmail": "tai jatka sähköpostilla",
    "loginOrSignupButton": "Seuraava",
    "login": "Kirjaudu",
    "passwordPlaceholder": "Salasana",
    "loginButton": "Seuraava",
    "logout": "Kirjaudu ulos",
    "logoutButton": "Jatka",
    "emailPlaceholder": "Sähköposti",
    "infoBox": {
      "title": "Aloita Jaakon käyttö",
      "bulletPoints": {
        "first": "Jaakko-tunnus syntyy hetkessä – tarvitset vain sähköpostin",
        "second": "Kirjautumalla voit ilmoittaa myynti- ja ostokiinnostuksesi – nappia painamalla",
        "third": "Tunnus tarvitaan, jotta voimme yhdistää sinut vastapuoleen"
      }
    },
    "registerText": {
      "first": "Rekisteröitymällä luot Jaakko-tunnuksen ja sitoudut noudattamaan palveluidemme ",
      "second": "käyttöehtoja",
      "third": ", sekä ilmoitat lukeneesi ja hyväksyväsi Jaakkocom Oy:n ",
      "fourth": "yleisen tietosuojakuvauksen."
    },
    "passwordRequirements": {
      "length": "Salasanan täytyy olla vähintään 8 merkkiä pitkä.",
      "uppercase": "Salasanan täytyy sisältää vähintään yksi iso kirjain.",
      "lowercase": "Salasanan täytyy sisältää vähintään yksi pieni kirjain.",
      "number": "Salasanan täytyy sisältää vähintään yksi numero."
    },
    "checkPassword": "Tarkista salasana.",
    "unexpectedError": "Hups! Jotain meni pieleen.",
    "signup": {
      "title": "Luo tunnus",
      "accountExists": "Näyttää siltä, että sinulla on jo tunnus. Kirjaudu sisään.",
      "signupButton": "Seuraava"
    },
    "emailVerification": {
      "title": "Vahvista sähköpostiosoite",
      "firstParagraph": "Anna vahvistuskoodi",
      "secondParagraph": "Anna koodi, joka lähetettiin sähköpostiosoitteeseesi {{email}} (jos et näe sähköpostia, tarkista roskapostikansio)",
      "codePlaceholder": "Vahvistuskoodi"
    },
    "forgotPassword": {
      "linkText": "Unohditko salasanasi?",
      "title": "Uusi salasana",
      "subtitle": "Syötä sähköpostiosoitteesi, niin lähetämme sinulle linkin salasanan uusimiseksi.",
      "submitMessage": "Jos tällä sähköpostiosoitteella on luotu tunnus, sinne on lähetetty salasanan uusimislinkki.",
      "sendLinkButton": "Lähetä uusimislinkki",
      "backToLogin": "Takaisin kirjautumiseen"
    },
    "resetPasswordPage": {
      "title": "Aseta uusi salasana",
      "newPasswordPlaceholder": "Uusi salasana",
      "confirmPasswordPlaceholder": "Vahvista uusi salasana",
      "submitButton": "Aseta uusi salasana",
      "passwordMismatch": "Salasanat eivät täsmää.",
      "successMessage": "Salasanasi on nollattu onnistuneesti. Voit nyt kirjautua sisään uudella salasanallasi.",
      "invalidLink": "Virheellinen tai vanhentunut salasanan nollauslinkki.",
      "tokenMissing": "Salasanan nollaustunniste puuttuu.",
      "goToLogin": "Siirry kirjautumiseen"
    }
  },
  "hints": {
    "clickBuilding": "Klikkaa mitä tahansa rakennusta",
    "zoomInToSeeHouseNumbers": "Zoomaa nähdäksesi talonumerot",
    "expressInterest": "Osoita myynti- tai ostokiinnostuksesi"
  },
  "metaTags": {
    "title": "Jaakko.com | Asuntokartta & hiljainen myynti",
    "description": "Voisitko myydä asuntosi, tai haluaisitko ostaa? Oman asunnon klikkaaminen hiljaiseen myyntiin, tai seuraavan unelmakodin etsiminen, on nyt helpompaa kuin koskaan.",
    "ogTitle": "Jaakko.com | Asuntokartta & hiljainen myynti",
    "ogDescription": "Voisitko myydä asuntosi, tai haluaisitko ostaa? Oman asunnon klikkaaminen hiljaiseen myyntiin, tai seuraavan unelmakodin etsiminen, on nyt helpompaa kuin koskaan.",
    "building": {
      "title": "Talosivu {{address}} - Jaakko.com",
      "description": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa.",
      "ogTitle": "Tutustu mielenkiintoiseen taloon Jaakko.com:issa",
      "ogDescription": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa."
    }
  },
  "shareButton": {
    "title": "Tutustu mielenkiintoiseen taloon Jaakko.com:issa",
    "text": "Tutustu {{address}}. Kerro myynti- tai ostokiinnostuksesta, keskustele tai seuraa.",
    "linkCopied": "Linkki taloon kopioitu leikepöydälle.",
    "linkCopiedError": "Linkin kopiointi epäonnistui. Kopioi linkki manuaalisesti."
  },
  "sharePrompt": {
    "sell": {
      "title": "Hienoa! Olet valmis myymään",
      "description": "Myyntikiinnostuksesi on lisätty. Jaa se löytääksesi ostajia nopeammin!",
      "matchTitle": "Mahtavaa! Myös ostajat ovat kiinnostuneita",
      "matchDescription": "Voitte nyt keskustella yksityisviesteissä. Jaa ilmoituksesi löytääksesi lisää ostajia!"
    },
    "buy": {
      "title": "Hienoa! Olet kiinnostunut ostamaan",
      "description": "Ostokiinnostuksesi on lisätty. Jaa se löytääksesi myyjiä nopeammin!",
      "matchTitle": "Mahtavaa! Myös myyjät ovat kiinnostuneita",
      "matchDescription": "Voitte nyt keskustella yksityisviesteissä. Jaa ilmoituksesi löytääksesi lisää myyjiä!"
    },
    "benefit": {
      "findMatchesSeller": "Löydä potentiaalisia ostajia nopeammin",
      "findMatchesBuyer": "Löydä potentiaalisia myyjiä nopeammin",
      "reachMore": "Tavoita enemmän kiinnostuneita",
      "faster": "Nopeuta prosessia"
    },
    "shareButton": "Jaa nyt",
    "skipButton": "Ehkä myöhemmin"
  },
  "messages": {
    "title": "Yksityisviestit",
    "empty": "Kun aloitat keskustelun ostajien tai myyjien kanssa, löydät kaikki viestit täältä.",
    "send": "Lähetä",
    "tabs": {
      "inbox": "Yksityisviestit",
      "all": "Kaikki",
      "support": "Tuki"
    },
    "firstMessage": "Keskustelunne alkaa tästä.",
    "welcomeTitle": "Keskustelunne alkaa tästä",
    "welcomeText": "Keskustelusi käyttäjän {{ email }} kanssa alkaa tästä. Voit keskustella asunnon yksityiskohdista ja esimerkiksi sopia näytön ajankohdan.",
    "welcomeTextOtherUserHasNotSentMessage": "Keskustelusi toisen osapuolen kanssa alkaa tästä. Voit keskustella asunnon yksityiskohdista ja esimerkiksi sopia näytön ajankohdan.",
    "welcomeTextEmailDisclaimer": "Huomioithan, että sähköpostiosoitteesi jaetaan vastapuolen kanssa, mikäli päätät aloittaa keskustelun tai vastata sinulle lähetettyihin viesteihin. Vastaavasti saat tietää vastapuolen sähköpostiosoitteen saadessasi ensimmäisen viestin.",
    "welcomeTips": "Vinkkejä onnistuneeseen neuvotteluun:",
    "tipPolite": "Ole kohtelias ja kunnioittava",
    "tipCaution": "Älä jaa arkaluontoisia tietoja ennen kuin olet varma vastapuolen luotettavuudesta",
    "tipDetails": "Voit lopettaa keskustelun milloin tahansa, jolloin vastapuolen viestit eivät enää tule sinulle",
    "writePlaceholder": "Kirjoita viesti...",
    "chatEndedPlaceholder": "Tämä keskustelu on päättynyt",
    "chatEndedMessage": "Tämä keskustelu on päättynyt. Uusia viestejä ei voi lähettää.",
    "chatEnded": "Keskustelu on päättynyt",
    "endChat": "Lopeta keskustelu",
    "endChatConfirmTitle": "Lopeta keskustelu",
    "endChatConfirmText": "Haluatko varmasti lopettaa tämän keskustelun? Lopettamisen jälkeen kumpikaan osapuoli ei voi enää lähettää viestejä tässä keskustelussa.",
    "confirm": "Lopeta keskustelu",
    "cancel": "Peruuta",
    "ending": "Lopetetaan",
    "today": "Tänään",
    "yesterday": "Eilen",
    "anonymousUser": "Anonyymi käyttäjä"
  },
  "exploreListings": {
    "exploreButton": "Selaa ilmoituksia",
    "title": "Myynti- ja ostokiinnostukset",
    "titleDesktop": "Myynti- ja ostokiinnostukset",
    "searchPlaceholder": "Hae sijainnilla",
    "filters": "Hakuehdot",
    "listingType": "Ilmoituksen tyyppi",
    "both": "Kaikki",
    "forSale": "Hiljaisessa myynnissä",
    "buyingInterests": "Ostokiinnostukset",
    "buyingInterest": "Ostokiinnostus",
    "propertySize": "Asunnon koko",
    "minSize": "Min",
    "maxSize": "Max",
    "rooms": "Huoneet",
    "any": "Kaikki",
    "floor": "Kerros",
    "minFloor": "Min",
    "maxFloor": "Max",
    "renovationStatus": "Remonttitilanne",
    "anyCondition": "Kaikki kunnot",
    "recentlyRenovated": "Äskettäin remontoitu",
    "goodCondition": "Hyvä kunto",
    "needsRenovation": "Tarvitsee remonttia",
    "amenities": "Varustelu",
    "hasElevator": "Hissi",
    "hasBalcony": "Parveke/Terassi",
    "clearAll": "Tyhjennä kaikki",
    "cancel": "Peruuta",
    "showResults": "Näytä tulokset",
    "resultsFound": "kohdetta hakuehdoilla",
    "noResultsTitle": "Ei hakutuloksia",
    "noResultsTitleSecondary": "Ei suoria hakutuloksia",
    "noResultsDescription": "Kokeile muuttaa suodattimia tai hakea eri sijainnista.",
    "endOfResults": "Olet nähnyt kaikki tulokset",
    "loading": "Ladataan...",
    "mapLoadError": "Virhe karttapalveluiden latauksessa",
    "mapLoading": "Ladataan karttapalveluita...",
    "today": "Tänään",
    "yesterday": "Eilen",
    "daysAgo": "{{days}} päivää sitten",
    "roomsShort": "h",
    "floorShort": "Krs",
    "elevator": "Hissi",
    "balcony": "Parveke",
    "contactSeller": "Ota yhteyttä myyjään",
    "contactBuyer": "Ota yhteyttä ostajaan",
    "viewOnMap": "Näytä kartalla",
    "interestedInBuying": "Hei! Olen kiinnostunut ostamaan tästä talosta.",
    "interestedInSelling": "Hei! Olen kiinnostunut myyntikiinnostuksestasi.",
    "openBuildingPage": "Avaa talosivu",
    "mightAlsoContain": "Nämä {{secondaryResultsCount}} ilmoitusta saattavat myös sisältää etsimäsi:"
  },
  "feedback": {
    "title": "Lähetä palautetta",
    "intro": "Haluamme kuulla mielipiteesi! Palautteesi auttaa meitä kehittämään Jaakkoa.",
    "type": {
      "label": "Palautteen tyyppi",
      "general": "Yleinen palaute",
      "bug": "Virheilmoitus",
      "feature": "Uusi toiminnallisuus -pyyntö",
      "improvement": "Parannusehdotus"
    },
    "email": {
      "label": "Sähköpostiosoitteesi",
      "placeholder": "sahkoposti@esimerkki.com",
      "help": "Vastaamme sähköpostiisi."
    },
    "subject": {
      "label": "Aihe",
      "placeholder": "Aihe"
    },
    "message": {
      "label": "Palautteesi",
      "placeholder": "Kerro ajatuksistasi, ehdotuksistasi tai raportoi kohtaamistasi ongelmista..."
    },
    "submit": "Lähetä palaute",
    "submitting": "Lähetetään...",
    "success": "Kiitos palautteestasi! Vastaamme sinulle pian sähköpostitse.",
    "validation": {
      "messageRequired": "Kirjoita palauteviestisi.",
      "emailRequired": "Anna sähköpostiosoitteesi.",
      "emailInvalid": "Anna kelvollinen sähköpostiosoite."
    },
    "error": {
      "submitFailed": "Palautteen lähetys epäonnistui. Yritä uudelleen."
    }
  }
};
